import { http } from '@/lib/ats-https';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  fullResponse?: boolean;
}

export const checkrCallback = async (data) => {
  const response = await http.post(`checkr/report_callback`, data, {
    fullResponse: true,
  } as CustomAxiosRequestConfig);
  return response;
};
